export const getCsrfCookieName = () =>
    // Read from a global var in a Django template until we figure out
    // how to do per-environment js config.
    // This is set in base.html and photos.html.
    typeof csrfCookieName !== "undefined" ? csrfCookieName : "csrftoken";
